import {
  getWencesApiBaseUrl,
  getWencesApiAuthHeaders,
} from "@/api/wencesApi";

/**
 * POST soporte IA con stream NDJSON: líneas { type: 'status', step, message } y final { type: 'result', data }.
 */
export async function postSupportAssistantNdjson(
  path,
  jsonBody,
  { signal, onStatus } = {}
) {
  const base = getWencesApiBaseUrl();
  const p = path.startsWith("/") ? path : `/${path}`;
  const url = `${base}${p}`;
  const headers = {
    ...getWencesApiAuthHeaders(),
    Accept: "application/x-ndjson, application/json",
  };
  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({ ...jsonBody, stream: true }),
    signal,
  });

  const ct = (res.headers.get("content-type") || "").toLowerCase();

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      if (j && (j.error != null || j.message != null)) {
        msg = String(j.error != null ? j.error : j.message);
      }
    } catch {
      try {
        const t = await res.text();
        if (t && t.trim()) msg = t.trim().slice(0, 500);
      } catch {
        /* ignore */
      }
    }
    throw new Error(msg);
  }

  if (!ct.includes("ndjson") && !ct.includes("x-ndjson")) {
    const data = await res.json();
    return { data, streamed: false };
  }

  const reader = res.body && res.body.getReader();
  if (!reader) {
    throw new Error("Sin cuerpo de respuesta");
  }

  const dec = new TextDecoder();
  let buf = "";
  let finalData = null;

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true });
      const lines = buf.split("\n");
      buf = lines.pop() || "";
      for (const line of lines) {
        if (!line.trim()) continue;
        let obj;
        try {
          obj = JSON.parse(line);
        } catch {
          continue;
        }
        if (obj.type === "status" && typeof onStatus === "function") {
          onStatus(obj);
        }
        if (obj.type === "result") finalData = obj.data;
        if (obj.type === "error") {
          throw new Error(obj.message || "Error");
        }
      }
    }
  } finally {
    try {
      reader.releaseLock();
    } catch {
      /* ignore */
    }
  }

  if (buf.trim()) {
    try {
      const obj = JSON.parse(buf);
      if (obj.type === "status" && typeof onStatus === "function") {
        onStatus(obj);
      }
      if (obj.type === "result") finalData = obj.data;
      if (obj.type === "error") {
        throw new Error(obj.message || "Error");
      }
    } catch (e) {
      if (e instanceof Error && e.message && e.message !== "Error") throw e;
    }
  }

  if (!finalData) {
    throw new Error("Respuesta incompleta del servidor");
  }
  return { data: finalData, streamed: true };
}

/** Texto bajo el spinner del chat de soporte (no duplicar si el mensaje va en burbuja). */
export function formatSupportAssistantProgress(_vm, obj) {
  if (!obj || typeof obj !== "object") return "";
  if (obj.step === "assistant_preview") {
    return "";
  }
  if (obj.message != null && String(obj.message).trim()) {
    return String(obj.message).trim();
  }
  const step = obj.step != null ? String(obj.step).trim() : "";
  const round = obj.round != null ? Number(obj.round) : null;
  if (step === "round_start" && round) {
    return `Paso ${round}: analizando tu pedido…`;
  }
  if (step === "model_wait" && round) {
    return `Paso ${round}: consultando al modelo…`;
  }
  if (step === "model_wait") {
    return "Consultando al modelo…";
  }
  return step ? step.replace(/_/g, " ") : "";
}
